var exports = {
  "e4": "visualContainer__pMR50x",
  "Cv": "visualImage__tJyP_v",
  "z7": "mobileArtwork__yxCOV_",
  "fN": "desktopArtwork__cx8t13",
  "ep": "visualShape__qpnJkr",
  "Yr": "wave-in__lQ2iiS",
};

module.exports = exports;
